<template>
<!-- 此component用在點檢跟稽核，要漸漸以WsSortDialogGeneral做替換 -->
  <div class="ws-sort-dialog">
    <WsDialog
      v-model="dialog"
      ref="WsDialog"
      @close="$_handleDialogClose()"
      :title="title"
    >

      <template v-slot:content>
        <WsSlickSort
          v-if="hasChapters"
          :sortList="createData"
          @sortList="$_updateList($event)"
        >
          <template v-slot="chapters">
            <WsSortItem
              v-if="!chapters.sortItem.chapterTitle"
              :error="true"
            >
              <v-icon
                size="20"
                class="mr-2"
              >mdi-information</v-icon>
              <span>{{errorMessages[0]}}</span>
            </WsSortItem>
            <WsSortItem v-else>
              {{chapters.sortItem.chapterTitle}}
            </WsSortItem>
            <WsSlickSort
              :sortList="createData[chapters.sortIndex].sections"
              @sortList="$_updateSectionList($event,chapters.sortIndex)"
            >
              <template v-slot="sections">
                <WsSortItem
                  v-if="!sections.sortItem.sectionTitle"
                  :error="true"
                  class="ws-sort-item__second"
                >
                  <v-icon
                    size="20"
                    class="mr-2 is-error"
                  >mdi-information</v-icon>
                  <span>{{errorMessages[1]}}</span>
                </WsSortItem>
                <WsSortItem
                  v-else
                  class="ws-sort-item__second"
                >
                  {{sections.sortItem.sectionTitle}}
                </WsSortItem>
                <WsSlickSort
                  :sortList="createData[chapters.sortIndex].sections[sections.sortIndex].topics"
                  @sortList="$_updateTopicList($event,chapters.sortIndex,sections.sortIndex)"
                >
                  <template v-slot="topics">
                    <WsSortItem
                      v-if="!topics.sortItem.id"
                      :error="true"
                      class="ws-sort-item__third"
                    >
                      <v-icon
                        size="20"
                        class="mr-2 is-error"
                      >mdi-information</v-icon>
                      <span>{{errorMessages[1]}}</span>
                    </WsSortItem>
                    <WsSortItem
                      v-else
                      class="ws-sort-item__third"
                    >
                      {{topics.sortItem.topicTitle}}
                    </WsSortItem>
                  </template>
                </WsSlickSort>
              </template>
            </WsSlickSort>
          </template>
        </WsSlickSort>
        <WsSlickSort
          v-else-if="!hasChapters"
          :sortList="createData"
          @sortList="$_updateList($event)"
        >
          <template v-slot="questions">
            <WsSortItem
              v-if="!questions.sortItem.title"
              :error="true"
            >
              <v-icon
                size="20"
                class="mr-2"
              >mdi-information</v-icon>
              <span>{{errorMessages[0]}}</span>
            </WsSortItem>
            <WsSortItem v-else>
              {{questions.sortItem.title}}
            </WsSortItem>
          </template>
        </WsSlickSort>
        <div
          v-if="isLoading"
          class="loading-section"
        >
          <v-progress-circular
            size="20"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </div>
      </template>
      <template v-slot:rightActions>
        <WsBtn
          @click="$_onCancel()"
          minWidth="100px"
          color="textSecondary"
          outlined
        >取消</WsBtn>
        <WsBtn
          @click="$_onSubmit()"
          minWidth="100px"
          :loading="submitLoading"
          color="primary"
        >送出</WsBtn>
      </template>
    </WsDialog>
  </div>
</template>
<script>
export default {
  data: () => ({
    submitLoading: false,
    dialog: false,
    submodelData: {},
    modelVersionData: {},
    createData: [],
    isLoading: false,
  }),
  props: {
    title: {
      type: String,
      default: "",
    },
    errorMessages: {
      type: Array,
      default() {
        return [];
      },
    },
    topics: {
      type: Array,
      default() {
        return [];
      },
    },
    submodelName: {
      type: String,
    },
    modelVersionName: {
      type: String,
    },
    modelData: {
      type: Object,
    },
    modelName: {
      type: String,
    },
    hasChapters: {
      type: Boolean,
    },
  },
  methods: {
    async $_fetchData() {
      this.isLoading = true;
      let params = {};
      params[`${this.modelName}s`] = this.$route.params.id;

      await this.$_getSubmodelData(`/${this.submodelName}`, params);
      await this.$_getModelVersionData();
      await this.$_getSequenceData(this.modelVersionData, this.submodelData);
      this.isLoading = false;
    },
    async $_getSubmodelData(getUrl, params) {
      try {
        const res = await this.$axios.get(getUrl, {
          params: params,
        });
        this.submodelData = res.data.data;
      } catch (error) {
        alert(error);
      }
    },
    async $_getModelVersionData() {
      try {
        let getUrl = `/${this.modelVersionName}/${this.modelData.last_version.id}`;
        const res = await this.$axios.get(getUrl);
        this.modelVersionData = res.data.data;
      } catch (error) {
        alert(error);
      }
    },
    $_getSequenceData(modelVersionData, submodelData) {
      let newArray;
      if (!modelVersionData) {
        this.createData = [];
        return;
      }
      newArray = JSON.parse(JSON.stringify(modelVersionData));
      if (this.hasChapters) {
        newArray.chapters.forEach((chapterItem) => {
          chapterItem.sections.forEach((sectionItem) => {
            sectionItem.topics.forEach((topicItem) => {
              submodelData.forEach((submodelItem) => {
                if (topicItem.id === submodelItem.id) {
                  topicItem.topicTitle = submodelItem.last_version.title;
                }
              });
            });
          });
        });
        this.createData = JSON.parse(JSON.stringify(newArray.chapters));
        this.createErrorMessages = ["尚未填寫章", "尚未填寫節"];
      } else if (newArray.questions) {
        newArray.questions.forEach((questionItem) => {
          submodelData.forEach((submodelItem) => {
            if (questionItem.id === submodelItem.id) {
              questionItem.title = submodelItem.last_version.title;
            }
          });
        });
        this.createErrorMessages = ["尚未填寫題目"];
        this.createData = JSON.parse(JSON.stringify(newArray.questions));
      }
    },
    $_handleDialogClose() {
      window.removeEventListener("keydown", this.$_keydownHandler);
    },
    $_keydownHandler(event) {
      if (event.metaKey && event.key === "Enter") {
        this.$_onSubmit();
      }
    },
    $_onSubmit() {
      if (this.createData) {
        this.$emit("updateSort", this.createData);
      }
      this.close();
    },
    $_onCancel() {
      this.close();
    },
    close() {
      this.dialog = false;
      window.removeEventListener("keydown", this.$_keydownHandler);
    },

    open() {
      this.$_fetchData();
      this.dialog = true;
    },
    $_updateList(val) {
      this.createData = val;
    },
    $_updateSectionList(val, chapterIndex) {
      this.createData[chapterIndex].sections = val;
    },
    $_updateTopicList(val, chapterIndex, sectionIndex) {
      this.createData[chapterIndex].sections[sectionIndex].topics = val;
    },
  },
};
</script>
<style lang="scss">
@import "../assets/scss/ws-sort-dialog.scss";
</style>
